











































































































































































































import {Component, Provide, Vue, Watch} from "vue-property-decorator";
import Loading from 'vue-loading-overlay';
import {mapGetters} from "vuex";
import axios from "axios";
import d3ToPng from "d3-svg-to-png";
import jsPDF from "jspdf";
import {IReportFilter, IReportForm, IReportLabels} from "./reports.interface";
import {ChartGroupKeys, ChartTypes, RangeFormats, RangeTypes} from "./report.enum";
import BarsLayeredChart from "../../components/charts/BarsLayeredChart.vue";
import PieChart from "../../components/charts/PieChart.vue";
import DateRange from "../../components/DateRange.vue";
import ReportsConfig from "./report-filter.config";
import Constants from "@/constants";
import {EventBus} from "@/event-bus";
import Fonts from "./fonts.const";
import moment from "moment";
import FilterForm from "../../pages/donorsForm/Filter.vue";

const DEFAULT_FILTER = {
    isSingleRegister: true,
    isYearInterval: true,
    dateFrom: '',
    dateTo: '',
    deleteDateFrom: '',
    deleteDateTo: '',
    gender: '',
    status: [],
    year: 2024,
    donorFormFilter: { }
};

const DEFAULT_FORM_CONFIG = {
    interval: false,
    period: false,
    register: false,
    gender: false,
    dateRange: true,
    deleteDateRange: false,
    status: false,
    donorForm: false,
    year: false,
    dateRangeFromLabel: 'Дата поступ. в орг. с:',
    dateRangeToLabel: 'Дата поступ. в орг. по:',
    deleteDateRangeFromLabel: 'Дата удаления с:',
    deleteDateRangeToLabel: 'Дата удаления по:',
};

const DEFAULT_REPORT = "CertificateReport";
const DEFAULT_LR_REPORT = "DonorFirstContactReport";

@Component({
    components: {
        PieChart,
        DateRange,
        FilterForm,
        Loading,
        BarsLayeredChart
    }
})

export default class Reports extends Vue {
    @Provide()
    parentValidator = this.$validator;
    reportType: string = DEFAULT_REPORT;
    chartType: string = ChartTypes.EXCEL;
    isReportReady: boolean = false;
    isLoading: boolean = false;
    range = [] as any;
    donorStatuses = [] as any;
    reportData = {} as any;
    rangeProperties = {
        format: RangeFormats.YEAR,
        type: RangeTypes.YEAR,
        shortcuts: false,
    };
    years: any[] = [];
    currentReportParams: IReportLabels = {};
    rangeTypes: Object = RangeTypes;
    chartGroupKeys: Object = ChartGroupKeys;
    isLayeredChart: boolean = false;
    formConfig: IReportForm = Object.assign({}, DEFAULT_FORM_CONFIG);
    filter: IReportFilter = Object.assign({}, DEFAULT_FILTER);

    get lrReportTypes() : Array<any> {
        return [
                { key: 'DonorFirstContactReport', value: this.$t('Первичные контакты с донорами') },
            ];
    }

    get reportTypes() : Array<any> {
        return [
            { key: 'CertificateReport', value: this.$t('Отчет по актам') },
            { key: 'CertificateStatisticsReport', value: this.$t('Статистический отчет по актам') },
            { key: 'WeeklyStatisticsReport', value: this.$t('Еженедельная статистика') },
            { key: 'OperatorEntryReport', value: this.$t('Отчет оператора') },
            { key: 'MedicalConsultantReport', value: this.$t('Отчет мед. консультанта') },
            { key: 'AdministratorCommunicationsReport', value: this.$t('Отчет администратора внешних коммуникаций') },
            { key: 'CommonMonthlyReport', value: this.$t('Ежемесячный отчет') },
            { key: 'GlobalTrendReport', value: this.$t('Отчет Global Trend') },
            { key: 'RegionStatisticsReport', value: this.$t('Статистика по регионам') },
            { key: 'DonorMailReport', value: this.$t('Почтовые адреса анкет') },
            { key: 'DonorFirstContactReport', value: this.$t('Первичные контакты с донорами') },
            { key: 'IncomeFromPostReport', value: this.$t('Поступления почтой России') },
            { key: 'FederalRegisterReport', value: this.$t('Отчет для актуализации наших доноров в Федеральном регистре') },
            { key: 'DonorDistribution', value: this.$t('Отчет по распределению доноров по регистрам') },
            { key: 'DonorsCountChanging', value: this.$t('Изменение количества доноров в регистре') },
            { key: 'DonorsExcludedCountChanging', value: this.$t('Изменение количества исключенных доноров в регистре') },
            { key: 'PatientFindPhenotypeCount', value: this.$t('Расчет количество обращений в регистр') },
            { key: 'PatientFindDonorCount', value: this.$t('Расчет количества активаций поиска') },
            { key: 'DonorsAgeMedian', value: this.$t('Медиана возрастов доноров') },
            { key: 'DonorsGenderRelation', value: this.$t('Соотношение доноров мужского/женского пола') },
            { key: 'DonorsControlTypingChanging', value: this.$t('Количество запросов для проведения контрольного типирования доноров') },
            { key: 'DonorsTransplantations', value: this.$t('Количество выполненных трансплантаций в зависимости от времени') },
        ];
    };
    get reportConfig(): any { return {
            CertificateReport: {
                type: 'excel',
                action: 'GetCertificatesReport',
                name: this.reportTypes[0].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата поступ. в орг. с:',
                    dateRangeToLabel: 'Дата поступ. в орг. по:',
                }
            },
            CertificateStatisticsReport: {
                type: 'excel',
                action: 'GetCertificateStatisticsReport',
                name: this.reportTypes[1].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата поступ. в орг. с:',
                    dateRangeToLabel: 'Дата поступ. в орг. по:',
                }
            },
            WeeklyStatisticsReport: {
                type: 'excel',
                action: 'GetWeeklyStatisticsReport',
                name: this.reportTypes[2].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата создания с:',
                    dateRangeToLabel: 'Дата создания по:',
                }
            },
            OperatorEntryReport: {
                type: 'excel',
                action: 'GetOperatorEntryReport',
                name: this.reportTypes[3].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата создания с:',
                    dateRangeToLabel: 'Дата создания по:',
                }
            },
            MedicalConsultantReport: {
                type: 'excel',
                action: 'GetMedicalConsultantReport',
                name: this.reportTypes[4].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата статуса:',
                    dateRangeToLabel: 'Дата статуса:',
                }
            },
            AdministratorCommunicationsReport: {
                type: 'excel',
                action: 'GetAdministratorCommunicationsReport',
                name: this.reportTypes[5].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата звонка с:',
                    dateRangeToLabel: 'Дата звонка по:',
                    status: true,
                }
            },
            CommonMonthlyReport: {
                type: 'excel',
                action: 'GetCommonMonthlyReport',
                name: this.reportTypes[6].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата создания с:',
                    dateRangeToLabel: 'Дата создания по:',
                }
            },
            GlobalTrendReport: {
                type: 'excel',
                action: 'GetGlobalTrendReport',
                name: this.reportTypes[7].value,
                filters: {
                    year: true
                }
            },
            RegionStatisticsReport: {
                type: 'excel',
                action: 'GetRegionStatisticsReport',
                name: this.reportTypes[8].value,
                filters: {
                    donorForm: true,
                }
            },
            DonorMailReport: {
                type: 'excel',
                action: 'GetDonorMailReport',
                name: this.reportTypes[9].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата создания с:',
                    dateRangeToLabel: 'Дата создания по:',
                    status: true,
                }
            },
            DonorFirstContactReport: {
                type: 'excel',
                action: 'GetDonorFirstContactReport',
                name: this.reportTypes[10].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата запроса с:',
                    dateRangeToLabel: 'Дата запроса по:',
                }
            },
            IncomeFromPostReport: {
                type: 'excel',
                action: 'GetIncomeFromPostReport',
                name: this.reportTypes[11].value,
                filters: {
                    dateRange: true,
                    dateRangeFromLabel: 'Дата запроса с:',
                    dateRangeToLabel: 'Дата запроса по:',
                }
            },
            FederalRegisterReport: {
                type: 'excel',
                action: 'GetFederalRegisterReport',
                name: this.reportTypes[12].value,
                filters: {
                    dateRange: true,
                    deleteDateRange: true,
                    dateRangeFromLabel: 'Активен с:',
                    dateRangeToLabel: 'Активен по:',
                    deleteDateRangeFromLabel: 'Удален с:',
                    deleteDateRangeToLabel: 'Удален по:',
                }
            },
            DonorDistribution: {
                type: 'pie_chart',
                name: this.reportTypes[13].value,
                filters: {}
            },
            DonorsCountChanging: {
                type: 'bars_layered_chart',
                name: this.reportTypes[14].value,
                filters: {
                    register: true,
                    period: true,
                    interval: true
                }
            },
            DonorsExcludedCountChanging: {
                type: 'bars_layered_chart',
                name: this.reportTypes[15].value,
                filters: {
                    register: true,
                    period: true,
                    interval: true
                }
            },
            PatientFindPhenotypeCount: {
                type: 'bars_layered_chart',
                name: this.reportTypes[16].value,
                filters: {
                    period: true,
                    interval: true
                }
            },
            PatientFindDonorCount: {
                type: 'bars_layered_chart',
                name: this.reportTypes[17].value,
                filters: {
                    period: true,
                    interval: true
                }
            },
            DonorsAgeMedian: {
                type: 'bars_layered_chart',
                name: this.reportTypes[18].value,
                filters: {
                    gender: true,
                    period: true,
                    interval: true
                }
            },
            DonorsGenderRelation: {
                type: 'bars_layered_chart',
                name: this.reportTypes[19].value,
                filters: {
                    period: true,
                    interval: true
                }
            },
            DonorsControlTypingChanging: {
                type: 'bars_layered_chart',
                name: this.reportTypes[20].value,
                filters: {
                    register: true,
                    period: true,
                    interval: true
                }
            },
            DonorsTransplantations: {
                type: 'bars_layered_chart',
                name: this.reportTypes[21].value,
                filters: {
                    register: true,
                    period: true,
                    interval: true
                }
            }
        }
    }

    created() {
        this.getDictionaries();
        this.years = [];
        this.reportType = this.$auth.user().isLr ? DEFAULT_LR_REPORT : DEFAULT_REPORT;
        for (let year = 2019; year <= moment().year(); year++) {
            this.years.push({ key: year, value: year });
        }
    }

    setFilter(form) {
        this.filter.donorFormFilter = form;
    }

    @Watch("filter.isYearInterval")
    onIsYearInterval(val: boolean) {
        this.rangeProperties.format = val ? RangeFormats.YEAR : RangeFormats.MONTH;
        this.rangeProperties.type = val ? RangeTypes.YEAR : RangeTypes.MONTH;
    }

    @Watch("reportType")
    onChangeReportType(val: string) {
        this.formConfig = this.reportConfig[val].filters as IReportForm;
        this.chartType = this.reportConfig[val].type;
        this.reportData = [];
        this.isReportReady = false;
        this.resetFilter();
    }

    onDateInput(value: any) {
        this.filter.dateFrom = value[0];
        this.filter.dateTo = value[1];
        this.range = value;
    }

    getChartData() {
        return axios.get(`${Constants.baseUrl}/Report/${this.reportType}`, {params: this.filter});
    }

    getDictionaries() {
    axios.get('/pmdd/DictionaryGroup')
        .then((response) => {
            this.donorStatuses = response.data.statuses;
        });
    }

    exportExcel() {
        let self = this;
        let reportParam = this.reportConfig[this.reportType];
        let from = this.filter.dateFrom ? moment(this.filter.dateFrom).format('YYYY-MM-DD') : '';
        let to = this.filter.dateTo ? moment(this.filter.dateTo).format('YYYY-MM-DD') : '';  
        let deleteFrom = this.filter.deleteDateFrom ? moment(this.filter.deleteDateFrom).format('YYYY-MM-DD') : '';
        let deleteTo = this.filter.deleteDateTo ? moment(this.filter.deleteDateTo).format('YYYY-MM-DD') : '';
        this.isLoading = true;
        const camelToSnakeCase = str => str.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        const filter = Object.fromEntries(Object.entries(this.filter.donorFormFilter)
                                                .map(([k, v]) => [camelToSnakeCase(k), v]));

        filter.year = this.filter.year;
        filter.date_from = from;
        filter.delete_date_from = deleteFrom;
        filter.date_to = to;
        filter.delete_date_to = deleteTo;
        if (this.filter.status === 'null') {
            this.filter.status = '';
        }
        filter.status = this.filter.status || filter.status;

        axios({
            url: Constants.baseUrl + '/pmdd/Reports/' + reportParam.action,
            method: 'POST',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json' },
            data: JSON.stringify(filter),
        })
        .then((response) => {
            self.isLoading = false;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            const fileName = `${reportParam.name}_${moment().format('YYYYMMDD')}.xlsx`;
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        })
    }

    exportPDF(e: Event) {
        e.preventDefault();
        e.stopPropagation();

        d3ToPng("#svg", "name", {
            quality: 1,
            download: false
        }).then((content: any) => {
            const doc = new jsPDF("p", "pt", "a4");

            doc.addFileToVFS("PTSans.ttf", Fonts.PTSans);
            doc.addFont("PTSans.ttf", "PTSans", "normal");
            doc.setFont("PTSans");
            doc.setFontSize(18);
            doc.text(this.currentReportParams.name, 40, 50);

            doc.setFontSize(10);

            if (this.currentReportParams.filters) {
                doc.text(this.currentReportParams.filters, 40, 70);
            }

            doc.addImage(content, "PNG", 40, 130, 520, 240);

            doc.save(`${this.currentReportParams.name}.pdf`);
        });
    }

    applyFilter(e: Event) {
        e.preventDefault();
        e.stopPropagation();

        this.isLayeredChart = this.chartType === ChartTypes.LAYERED;
        this.isReportReady = false;
        this.currentReportParams = {};
        EventBus.$emit("showThrobber");

        this.getChartData()
            .then((result) => {
                EventBus.$emit("hideThrobber");
                this.currentReportParams = this.getChartLabels();
                this.reportData = result.data;
                this.isReportReady = true;
            })
            .catch((error) => {
                EventBus.$emit("hideThrobber");

                if (error.data) {
                    EventBus.$emit("error", {msg: error.data});
                }
            });
    }

    getChartLabels() {
        const reportFilters = this.reportConfig[this.reportType].filters,
            result = {
                name: this.reportConfig[this.reportType].name,
                filters: ""
            };

        if (reportFilters.register || reportFilters.interval || reportFilters.gender) {
            result.filters = this.$t('Расчёт показателя ') as string;
        }

        if (reportFilters.register) {
            result.filters += this.$t('для') + ` ${this.filter.isSingleRegister ? this.$t('единого') : this.$t('локального')} ` + this.$t('регистра');
        }

        if (reportFilters.interval) {
            if (reportFilters.register !== undefined) {
                result.filters += ", \n\r";
            }

            result.filters += `${this.$t('с шагом интервала')} ${this.filter.isYearInterval ? this.$t('Год') : this.$t('Месяц')}`;

            if (this.filter.isYearInterval) {
                result.filters += ` ` + this.$t('c') + ` ${moment(this.filter.dateFrom).format("YYYY")} `+ this.$t('по') + ` ${moment(this.filter.dateTo).format("YYYY")}`;
            } else {
                result.filters += ` ` + this.$t('c') + ` ${moment(this.filter.dateFrom).format("MM.YYYY")} `+ this.$t('по') + ` ${moment(this.filter.dateTo).format("MM.YYYY")}`;
            }
        }

        if (reportFilters.gender !== undefined) {
            if (reportFilters.register || reportFilters.interval) {
                result.filters += ", \n\r";
            }

            let gender = this.$t('мужского');

            if (this.filter.gender === "2") {
                gender = this.$t('женского');
            } else if (this.filter.gender === null) {
                gender = this.$t('любого');
            }

            result.filters += this.$t('для') + ` ${gender} ` + this.$t('пола');
        }

        if (reportFilters.register || reportFilters.interval || reportFilters.gender) {
            result.filters += ".";
        }

        return result;
    }

    resetFilter() {
        this.filter = Object.assign({}, DEFAULT_FILTER);
        this.range = [];
        this.$validator.reset();
    }
};
